import { render } from "./videoDetails.vue?vue&type=template&id=70557c48"
import script from "./videoDetails.vue?vue&type=script&lang=js"
export * from "./videoDetails.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__